import { render, staticRenderFns } from "./rekondpdb.vue?vue&type=template&id=08d3e7d0&scoped=true"
import script from "./rekondpdb.vue?vue&type=script&lang=js"
export * from "./rekondpdb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d3e7d0",
  null
  
)

export default component.exports